import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";

export const getComprobanteCajaChicaEnc = async(dates) =>{
    const result = await PrivateInterceptor(`Finanzas/CajaChica/Encabezado`, 'POST', {FechaInicio :dates[0], FechaFinal: dates[1]} );
    return result;
}

export const getBoletaCompra = async(dates) =>{
    const result = await PrivateInterceptor(`Finanzas/CajaChica/getBoletaCompra`, 'POST', {FechaInicio :dates[0], FechaFinal: dates[1]} );
    return result;
}

export const getBoletaCompraPorEncID = async(IdBoletaCompraEnc) =>{
    const result = await PrivateInterceptor(`Finanzas/CajaChica/getBoletaCompraPorEncID`, 'POST', {IdBoletaCompraEnc});
    return result;
}

export const getBoletaCompraPorDetID = async(IdBoletaCompraEnc) =>{
    const result = await PrivateInterceptor(`Finanzas/CajaChica/getBoletaCompraPorDetID`, 'POST', {IdBoletaCompraEnc});
    return result;
}

export const GuardarBoleta = async (Encabezado, Detalles) => {
    const respuesta = PrivateInterceptor("Finanzas/CajaChica/GuardarBoleta", "POST",{Encabezado, Detalles});
    return respuesta;
};

export const EditarBoleta = async (Encabezado, Detalles) => {
    const respuesta = PrivateInterceptor("Finanzas/CajaChica/EditarBoleta", "POST",{Encabezado, Detalles});
    return respuesta;
};


export const eliminarDetallesBoleta = async(Ids) =>{
    const result = await PrivateInterceptor('Finanzas/CajaChica/eliminarDetallesBoleta','POST', {Ids})
    return result
}

export const eliminarBoleta = async(Ids, IdRango) =>{
    const result = await PrivateInterceptor('Finanzas/CajaChica/eliminarBoleta','POST', {Ids, IdRango})
    return result
}

export const AnularBoletaCompra = async(Datos) =>{
    const result = await PrivateInterceptor('Finanzas/CajaChica/AnularBoleta','POST', {Datos})
    return result
}

export const EntregarBoletaCompra = async(Datos) =>{
    const result = await PrivateInterceptor('Finanzas/CajaChica/EntregarBoleta','POST', {Datos})
    return result
}